
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 499","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-rule":"evenodd","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"445","cy":"249.6","r":"19.5"}}),_c('circle',{attrs:{"cx":"67.1","cy":"249.6","r":"19.5"}}),_c('ellipse',{attrs:{"cx":"256","cy":"327.8","rx":"26.1","ry":"13"}}),_c('path',{attrs:{"d":"M256 92c-87.3 0-157.7 70.4-157.7 157.7 0 49.5 23.5 93.8 58.6 122.5 20.9 20.8 57.3 35.2 99 35.2s78.2-14.3 99-35.2c36.5-28.7 58.6-73 58.6-122.5C413.7 162.3 343.3 92 256 92zm79.5 259.3c-22.2 16.9-49.5 27.4-79.5 27.4s-57.3-10.4-79.5-27.4c-6.5-7.8-10.4-14.3-10.4-23.5 0-27.4 40.4-50.8 89.9-50.8s89.9 23.5 89.9 50.8c0 7.8-3.9 15.6-10.4 23.5zm35.2-44.3c-13-33.9-58.6-58.6-114.7-58.6-56 0-101.6 24.8-114.7 58.6-9.1-16.9-14.3-36.5-14.3-57.3 0-70.4 57.3-129 129-129s129 57.3 129 129c0 20.8-5.2 40.3-14.3 57.3z"}}),_c('path',{attrs:{"d":"M256 .7C119.2.7 7.1 112.8 7.1 249.6S119.2 498.5 256 498.5s248.9-112.1 248.9-248.9S394.1.7 256 .7zm0 469.1c-121.2 0-220.2-99-220.2-220.2S134.8 29.4 256 29.4s220.2 99 220.2 220.2-99 220.2-220.2 220.2z"}})])])
          )
        }
      }
    